import { useI18n } from "../context/I18nContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";

export function CompanyDocsSection({ settings, setSettings, onSave }) {
  const { t } = useI18n();
  if (!settings) return null;
  const f = (key, label, extra = {}) => (
    <div className="space-y-1">
      <Label className="text-[10px] font-bold uppercase tracking-widest">{label}</Label>
      <Input value={settings[key] ?? ""} onChange={(e) => setSettings({ ...settings, [key]: e.target.value })}
        className="rounded-none h-8 text-xs" data-testid={`settings-${key.replace(/_/g, "-")}`} {...extra} />
    </div>
  );
  return (
    <div className="border bg-card p-5 mb-4" data-testid="company-docs-section">
      <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-muted-foreground mb-3">{t("set.companyDocs")}</div>
      <div className="grid grid-cols-2 gap-3 mb-3">
        <div className="col-span-2">{f("company_address", t("set.companyAddress"))}</div>
        {f("company_rfc", t("set.companyRfc"))}
        {f("company_email", t("set.companyEmail"), { type: "email" })}
        {f("company_phone", t("set.companyPhone"))}
        <div className="col-span-2">{f("po_footer_note", t("set.poFooter"))}</div>
        <div className="col-span-2 space-y-1">
          <Label className="text-[10px] font-bold uppercase tracking-widest">{t("set.paymentPolicy")}</Label>
          <Textarea value={settings.payment_policy ?? ""} rows={10}
            onChange={(e) => setSettings({ ...settings, payment_policy: e.target.value })}
            className="rounded-none text-xs font-mono" data-testid="settings-payment-policy" />
        </div>
      </div>
      <Button size="sm" onClick={onSave} className="rounded-none text-xs font-bold" data-testid="settings-save-company-docs">{t("common.save")}</Button>
    </div>
  );
}
